import React from 'react';

const EmptyMsg = () => {
    return(
        <p className="white p-5 mx-auto">{ process.env.REACT_APP_PARTICIPATION_EMPTYMSG }</p>
    );
}
export default EmptyMsg;